import { Injectable } from '@angular/core';
import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { VersionService } from '@shared/services/version.service';

export const API_VERSION_HEADER_NAME = 'x-api-version';

@Injectable()
export class ApiVersionInterceptor implements HttpInterceptor {
  constructor(private versionService: VersionService) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((response) => {
        if (response.type === HttpEventType.Response) {
          const version = response.headers.get(API_VERSION_HEADER_NAME);

          if (version) {
            this.versionService.setApiVersion(version);
          }
        }
      })
    );
  }
}
